import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 12l-12 6.75m12 -6.75l-12 -6.75m12 6.75v-4.527l-8 -4.473l-4 2.25m12 6.75v4.5l-8 4.5l-4 -2.25m0 -13.5l-4 2.222v9.028l4 2.25l12 -6.75","key":"svg-0"}]]

const IconBrandTabnine = createReactComponent('outline', 'brand-tabnine', 'BrandTabnine', __iconNode);

export default IconBrandTabnine;